import CloudComputingPowerRouterView from '@/CloudComputingPowerRouterView'
import DebitCardRouterView from '@/DebitCardRouterView'
import { PageRoutes } from '@/constants/PageRoutes'
import ContractTrade from '@/views/ContractTrade'
import SpotTrade from '@/views/SpotTrade'
import { CloudComputingPowerRoutes } from 'cloud-computing-power/router'
import { debitCardRoutes } from 'debit-card/router'
import type { RouteRecordRaw } from 'vue-router'
import { handleModuleRoutes } from './router.config'

const CloudModule = import.meta.env.VITE_CLOUD_ROUTE_MODULE
const DebitCard = import.meta.env.VITE_DEBIT_CARD_MODULE
/**  */
export const getCryptoRouter = (): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = [
    {
      path: '/:pathMatch(.*)*',
      redirect: PageRoutes.Home,
    },
    {
      path: PageRoutes.Home,
      component: () => import('@/views/HomeView'),
      meta: {
        title: '首页',
      },
    },
    {
      path: PageRoutes.Quote,
      component: () => import('@/views/QuoteView/QuoteView'),
      meta: {
        title: '行情',
      },
    },
    {
      path: PageRoutes.SpotTrade,
      component: SpotTrade,
      meta: {
        title: '现货',
      },
    },
    {
      path: PageRoutes.ContractTrade,
      component: ContractTrade,
      meta: {
        title: '合约交易',
      },
    },
    ...(CloudModule
      ? [
          {
            path: CloudModule,
            component: CloudComputingPowerRouterView,
            children: handleModuleRoutes(CloudComputingPowerRoutes, CloudModule),
          },
        ]
      : []),
    ...(DebitCard
      ? [
          {
            path: DebitCard,
            component: DebitCardRouterView,
            children: handleModuleRoutes(debitCardRoutes, DebitCard),
          },
        ]
      : []),
  ]

  return routes
}
